import { $$ } from '../utils/dom.js';
import { on } from '../utils/events.js';

export function initTabs() {
  const roots = $$('[data-component="tabs"]');
  const disposers = roots.map((root) => setupTabs(root));

  return () => {
    disposers.forEach((dispose) => {
      dispose();
    });
  };
}

function setupTabs(root) {
  const triggers = $$('[data-tab-trigger]', root);
  const panels = $$('[role="tabpanel"]', root);

  const activateTab = (trigger) => {
    const panelId = trigger.getAttribute('aria-controls');

    triggers.forEach((tab) => {
      const isActive = tab === trigger;
      tab.setAttribute('aria-selected', String(isActive));
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.id === panelId;
      if (isActive) {
        panel.removeAttribute('hidden');
        panel.setAttribute('data-state', 'active');
      } else {
        panel.setAttribute('hidden', '');
        panel.setAttribute('data-state', 'inactive');
      }
    });
  };

  const initial =
    triggers.find((tab) => tab.getAttribute('aria-selected') === 'true') ||
    triggers[0];

  if (initial) {
    activateTab(initial);
  }

  const removeClick = on(root, 'click', '[data-tab-trigger]', (event) => {
    const trigger = event.target.closest('[data-tab-trigger]');
    if (!trigger) {
      return;
    }
    activateTab(trigger);
  });

  const removeKeydown = on(root, 'keydown', '[data-tab-trigger]', (event) => {
    const trigger = event.target.closest('[data-tab-trigger]');
    if (!trigger) {
      return;
    }

    const index = triggers.indexOf(trigger);
    let nextIndex = index;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (index + 1) % triggers.length;
      event.preventDefault();
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (index - 1 + triggers.length) % triggers.length;
      event.preventDefault();
    } else if (event.key === 'Home') {
      nextIndex = 0;
      event.preventDefault();
    } else if (event.key === 'End') {
      nextIndex = triggers.length - 1;
      event.preventDefault();
    } else {
      return;
    }

    const nextTrigger = triggers[nextIndex];
    nextTrigger.focus();
    activateTab(nextTrigger);
  });

  return () => {
    removeClick();
    removeKeydown();
  };
}
